/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(value) {
    if (!('StoreSpecificOrderProductSku' in value) || value['StoreSpecificOrderProductSku'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'StoreSpecificOrderProductSku': json['StoreSpecificOrderProductSku'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'StoreSpecificOrderProductSku': value['StoreSpecificOrderProductSku'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions.js.map